import React from "react";
import { Link } from "react-router-dom";

const PostsIndex = ({ posts }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-4 md:p-6">
      {posts.map((post) => {
        const image = post.thumbnail || post.image;

        return (
          <Link
            key={post.slug}
            to={`/posts/${post.slug}`}
            className="group bg-white rounded overflow-hidden shadow-md border border-gray-200 hover:ring-4 hover:ring-orange-500"
          >
            <div className="relative aspect-[16/10] overflow-hidden bg-gray-800">
              {image && (
                <img
                  src={`${process.env.REACT_APP_IMG_URL}/${image}`}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                  decoding="async"
                />
              )}

              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 transition-opacity duration-200 group-hover:opacity-100" />

              <div className="absolute inset-x-0 bottom-0 p-4">
                <h3 className="font-semibold text-white text-base mb-1">
                  {post.title}
                </h3>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default PostsIndex;